import { apiFetch } from './apiClient';
import { defaultErrorMessage } from './httpRequest';
import type { DrawingDocument } from '@peruselab/contracts';

export interface PrivateTemplate {
  readonly id: string;
  readonly name: string;
  readonly document: DrawingDocument;
  readonly authorId: string;
  readonly authorName: string;
  readonly revision: number;
}
async function request<T>(path = '', init?: RequestInit): Promise<T> {
  const response = await apiFetch(`/me/templates${path}`, init);
  if (!response.ok) throw new Error(await defaultErrorMessage(response, 'templates'));
  return response.status === 204 ? (undefined as T) : ((await response.json()) as T);
}
export const listPrivateTemplates = () => request<readonly PrivateTemplate[]>();
export const createPrivateTemplate = (name: string, document: DrawingDocument) =>
  request<PrivateTemplate>('', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, document })
  });
export const renamePrivateTemplate = (template: PrivateTemplate, name: string) =>
  request<PrivateTemplate>(`/${encodeURIComponent(template.id)}`, {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ name, revision: template.revision })
  });
export const deletePrivateTemplate = (id: string) => request<void>(`/${encodeURIComponent(id)}`, { method: 'DELETE' });
